import React from "react";
import { useMembersPage } from "./hooks/useMembersPage";
import MemberFormModal from "./components/MemberFormModal";
import { ContentLoader, DataTable, Breadcrumb } from "../../components/Common";
import { useNavigate } from "react-router-dom";
import { getMembersColumns, MEMBER_STATUS_TABS } from "./constants";
import "./Members.css";

import { Button, Input, InputGroup, Nav, NavItem, NavLink } from "reactstrap";

const MembersPage = () => {

    const navigate = useNavigate();
    const {
        members,
        isInitialLoading,
        searchTerm,
        setSearchTerm,
        statusFilter,
        setStatusFilter,
        isModalOpen,
        handleToggleModal,
        formState,
        isSaving,
        handleSave,
        isReady
    } = useMembersPage();



    if (!isReady || isInitialLoading) {
        return <ContentLoader loading={true} message="Carregando clientes..." />;
    }

    // Columns configuration for the DataTable
    const columns = getMembersColumns(navigate);

    return (
        <React.Fragment>
            {/* Header: título + botão na mesma linha */}
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Clientes" />
                <Button
                    color="primary"
                    className="px-4 d-flex align-items-center fw-bold rounded-0 flex-shrink-0"
                    onClick={handleToggleModal}
                >
                    Novo Cliente
                </Button>
            </div>

            {/* Linha bem suave separando */}
            <div className="border-top mb-3"></div>

            {/* Layout sem Card: Dados diretamente no fundo */}
            <div className="members-list-container mt-3">
                {/* Search & Tabs na mesma linha */}
                <div className="d-flex align-items-center justify-content-between pb-3 flex-wrap gap-3">

                    <Nav tabs className="status-tabs-nav">
                        {MEMBER_STATUS_TABS.map((tab) => (
                            <NavItem key={tab.value}>
                                <NavLink
                                    className={`status-tab-link ${statusFilter === tab.value ? "active" : ""}`}
                                    onClick={() => setStatusFilter(tab.value)}
                                >
                                    {tab.label}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>

                    <div className="search-box-premium flex-shrink-0">
                        <InputGroup className="bg-white border rounded-0 overflow-hidden">
                            <span className="input-group-text bg-transparent border-0 ps-3">
                                <i className="mdi mdi-magnify text-muted font-size-18"></i>
                            </span>
                            <Input
                                type="text"
                                className="form-control bg-transparent border-0 ps-1 font-size-14 shadow-none"
                                placeholder="Buscar cliente..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </InputGroup>
                    </div>
                </div>

                <DataTable
                    columns={columns}
                    data={members}
                    keyField="id"
                    isLoading={false}
                    noCard={true}
                    emptyMessage="Nenhum cliente disponível"
                    emptySubMessage="Clique em 'Novo Cliente' para começar o cadastro."
                />
            </div>

            {/* Modal de Formulário */}
            <MemberFormModal
                isOpen={isModalOpen}
                toggle={handleToggleModal}
                onSave={handleSave}
                data={formState}
                isSaving={isSaving}
            />
        </React.Fragment>
    );
};

export default MembersPage;
